import {Directive, ElementRef, HostListener, Optional} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
    selector: '[trim]'
})
export class TrimDirective {

    constructor(private el: ElementRef, @Optional() private ngControl: NgControl) {
    }

    @HostListener('ionBlur') onBlur() {
        if (this.ngControl && this.ngControl.value) {
            const trimmed = this.ngControl.value.trim();
            if (trimmed.length !== this.ngControl.value.length) {
                this.ngControl.control.setValue(trimmed);
            }
        }
    }
}
